import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { loadScript, OrderResponseBody } from '@paypal/paypal-js';

const MAX_RETRIES = 3;
@Component({
  selector: 'app-payment-paypal',
  templateUrl: './payment-paypal.component.html',
  styleUrls: ['./payment-paypal.component.scss'],
})
export class PaymentPaypalComponent implements OnInit {
  @Input() amount: number;
  @Input() clientId: string;
  @Output() paymentSuccess = new EventEmitter<OrderResponseBody>();
  @Output() error = new EventEmitter<string>();
  loading = true;
  maxRetries = MAX_RETRIES;
  try = 0;

  ngOnInit(): void {
    this.initConfig(this.clientId, this.amount);
  }

  private async initConfig(clientId: string, amount: number): Promise<void> {
    // Check if max retries reached
    if (this.try >= 3) {
      console.error('Max retries reached');
      this.error.emit('Max retries reached. Paypal is not available. Please try again later.');
      return;
    }
    if (!clientId || !amount) {
      console.error('No se ha proporcionado un clientId para PayPal');
      return;
    }
    const value = amount.toFixed(2);

    let paypal;

    try {
      paypal = await loadScript({ clientId, currency: 'MXN', components: 'buttons', locale: 'es_MX' });
    } catch (error) {
      console.error('failed to load the PayPal JS SDK script', error);
      console.error('Retrying... ' + this.try);
    }

    if (paypal) {
      try {
        await paypal
          .Buttons({
            fundingSource: paypal.FUNDING.PAYPAL, // Only show the PayPal button

            createOrder: (data, actions) => {
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      currency_code: 'MXN',
                      value,
                    },
                  },
                ],
              });
            },
            onInit: () => {
              this.loading = false;
            },
            onApprove: async (data, actions) => {
              const order: OrderResponseBody = await actions.order.capture();
              this.paymentSuccess.emit(order);
            },
            onError: (error) => {
              console.error('failed to capture the order', error);
            },
          })
          .render('#paypal-button-container');
      } catch (error) {
        console.error('failed to render the PayPal Buttons', error);
        console.error('Retrying... ' + this.try);
        this.retry();
      }
    }
  }

  retry(): void {
    this.try++;
    this.loading = true;
    this.initConfig(this.clientId, this.amount);
  }
}
